// src/components/Footer.js
import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import ReviewsCTA from "./ReviewsCTA";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-inner">
        {/* Bloc 1 — Marque / accroche */}
        <div className="footer-col">
          <div className="footer-brand">
            <strong>HLBK</strong>
            <div className="footer-tagline">Photographe — mariages, portraits & familles</div>
          </div>
          <div className="footer-loc">Basé à Tomblaine / Nancy — déplacements Grand Est</div>
        </div>

        {/* Bloc 2 — Contact rapide */}
        <div className="footer-col">
          <div className="footer-title">Contact</div>
          <a className="footer-link" href="mailto:contact@hlbk.fr">
            contact@hlbk.fr
          </a>
          <div className="footer-note">Réponse sous 24–48h (hors week-end)</div>
        </div>

        {/* Bloc 3 — Réseaux + Avis */}
        <div className="footer-col footer-col-right">
          <div className="footer-title">Me suivre</div>

          <div className="footer-socials" aria-label="Réseaux sociaux">
            <a
              href="https://www.facebook.com/profile.php?id=61565497088426"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              title="Facebook"
            >
              <FaFacebookF size={18} />
            </a>
            <a
              href="https://www.instagram.com/hlbkphoto"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              title="Instagram"
            >
              <FaInstagram size={18} />
            </a>
          </div>

          <div className="footer-reviews">
            <ReviewsCTA
              href="https://g.page/r/CWoruq03bw4oEAE/review"
              text="Laisser un avis Google"
            />
          </div>
        </div>
      </div>

      {/* bas de page */}
      <div className="footer-bottom">
        <p>© {year} HLBK — Tous droits réservés</p>

        <div className="footer-legal">
          {/* Mets ces routes si tu as les pages, sinon remplace par des liens externes */}
          <a className="footer-legal-link" href="/mentions-legales">
            Mentions légales
          </a>
          <span aria-hidden="true">·</span>
          <a className="footer-legal-link" href="/confidentialite">
            Confidentialité
          </a>
          <span aria-hidden="true">·</span>
          <a className="footer-legal-link" href="/CGV">
            Conditions Générales de Vente
          </a>

          {/* Optionnel : passerelle vers ton site pro */}
          <span aria-hidden="true">·</span>
          <a
            className="footer-legal-link"
            href="https://maximeh.fr/"
            target="_blank"
            rel="noreferrer"
          >
            Envie d'un petit creux ?
          </a>
        </div>
      </div>
    </footer>
  );
}